import { YouTubeChannelLookupActionTypes } from '@store/drafts'

export const lookupYouTubeChannel = (handle: string) => ({
  payload: { handle },
  type: YouTubeChannelLookupActionTypes.LOOKUP_REQUEST,
})

export const lookupYouTubeChannelSuccess = (found: boolean) => ({
  payload: { found },
  type: YouTubeChannelLookupActionTypes.LOOKUP_SUCCESS,
})

export const lookupYouTubeChannelError = (error: any) => ({
  payload: error,
  type: YouTubeChannelLookupActionTypes.LOOKUP_ERROR,
})
